var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32532 2.1333C7.32532 3.30966 6.36838 4.26659 5.19202 4.26659C4.01566 4.26659 3.05872 3.30966 3.05872 2.1333C3.05872 0.956936 4.01566 0 5.19202 0C6.36838 0 7.32532 0.956936 7.32532 2.1333ZM0.924316 7.46659C0.924316 6.04642 3.76465 5.33329 5.19091 5.33329C6.61717 5.33329 9.45751 6.04642 9.45751 7.46659V7.53324C9.45751 8.08552 9.00979 8.53324 8.45751 8.53324H1.92432C1.37203 8.53324 0.924316 8.08552 0.924316 7.53324V7.46659ZM9.48527 5.37002C10.1923 5.88201 10.6799 6.56466 10.6799 7.46675C10.6799 7.46675 10.6548 7.78898 10.5239 8.06569C10.3929 8.34239 10.1968 8.53339 10.1968 8.53339H12.0513C12.6404 8.53339 13.118 8.05584 13.118 7.46675C13.118 6.23553 10.9847 5.53459 9.48527 5.37002ZM10.9813 2.1333C10.9813 3.30966 10.0243 4.26659 8.84796 4.26659C8.51882 4.26659 8.21407 4.18736 7.93369 4.05327C8.31768 3.5108 8.5432 2.84643 8.5432 2.1333C8.5432 1.42017 8.31768 0.755797 7.93369 0.21333C8.21407 0.0792368 8.51882 0 8.84796 0C10.0243 0 10.9813 0.956936 10.9813 2.1333Z",
    fill: "#818291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/followers.6a13807742bb84010949fac9dab6c095.svg";
export { ForwardRef as ReactComponent };